import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=9370b86a"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports